export const SN_PRODUCT = 'product'
export const PRODUCT_ADD_TO_CACHED_MULTIPLE = SN_PRODUCT + '/ADD_TO_CACHED_MULTIPLE'
export const PRODUCT_LIST_UPDATED = SN_PRODUCT + '/LIST_UPDATED'